export default {
    modal_title: "Agregar estopa",
    unit_price: "Valor unitario",
    quantity: "Cantidad",
    subtotal_with_colon: "Subtotal:",
    cancel: "Cancelar",
    add: "Agregar",
    client_search_placeholder: "Buscar cliente...",
    client_1: "Cliente 1",
    client_2: "Cliente 2",
    client_3: "Cliente 3",
    product_search_placeholder: "Buscar producto...",
    product_1: "Producto 1",
    product_2: "Producto 2",
    product_3: "Producto 3",
    product: "Producto",
    subtotal: "Subtotal",
    total: "Total",
    add_product: "Agregar producto",
    advance_payment: "Avanzar al pago",
    coupon: "Cupon",
    apply: "Aplicar",
    save_sale: "Guardar venta",
    sale_success: "Venta realizada con exito!",
    new_sale: "Nueva venta",
};
